import React, { useState } from 'react'
import { css } from '@emotion/css'
import {
  TableContainer,
  Table,
  TablePagination,
  TableBody,
} from '@mui/material'
import { TableHead, HeadCell, Order } from 'components/TableHead'
import { Rows, RowData } from './Rows'
import { getComparator, stableSort } from 'utils/table-stable-sort'
// import { Dialog, DialogContentDelete } from 'components/Dialog'

import { useSelector } from 'react-redux'
// import { useAppDispatch } from 'store'
import { selectAllStaffRows } from 'features/staff/staffSlice'

type Property = keyof RowData

const headCells: HeadCell<Property>[] = [
  {
    id: 'display_name',
    label: 'ชื่อ',
    disablePadding: true,
    numeric: false,
  },
  {
    id: 'email',
    label: 'อีเมล',
    disablePadding: true,
    numeric: false,
  },
  {
    id: 'role',
    label: 'สิทธิ์การเข้าถึง',
    disablePadding: false,
    numeric: false,
  },
  {
    id: 'is_suspended',
    label: 'สถานะ',
    disablePadding: false,
    numeric: false,
  },
]

export function TableStaff() {
  const [order, setOrder] = useState<Order>('desc')
  const [orderBy, setOrderBy] = useState<Property>('display_name')

  const rows = useSelector(selectAllStaffRows)
  // const dispatch = useAppDispatch()

  function hanleEditClick(payload: RowData) {}
  // function handleDialogEditClose() {}
  function handleDeleteClick(payload: RowData) {}

  // function handleDialogDeleteClose() {}

  // function handleSubmit(payload: any) {}

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)

  // const emptyRows = React.useMemo(
  //   () => (page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0),
  //   [page, rowsPerPage, rows]
  // )

  function hanldeRequestSort(property: Property) {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  function handlePageChange(event: unknown, newPage: number) {
    setPage(newPage)
  }

  function handleRowsPerPageChange(event: React.ChangeEvent<HTMLInputElement>) {
    setRowsPerPage(parseInt(event.target.value, 10))
  }

  return (
    <>
      <TableContainer sx={{ maxHeight: 500 }}>
        <Table stickyHeader aria-label="table-staff">
          <TableHead<Property>
            headCells={headCells}
            onRequestSort={hanldeRequestSort}
            order={order}
            orderBy={orderBy}
          />
          <TableBody>
            <Rows
              data={
                stableSort(rows, getComparator(order, orderBy)).slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                ) || []
              }
              headCells={headCells}
              onDelete={handleDeleteClick}
              onEdit={hanleEditClick}
            />
          </TableBody>
        </Table>
      </TableContainer>
      {!rows?.length && (
        <p
          className={css`
            text-align: center;
            text-decoration: underline;
          `}
        >
          ไม่มีข้อมูล
        </p>
      )}
      <TablePagination
        labelRowsPerPage="แถวต่อหน้า"
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={rows?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onRowsPerPageChange={handleRowsPerPageChange}
        onPageChange={handlePageChange}
      />
    </>
  )
}

export default TableStaff
